/* eslint-disable @typescript-eslint/no-explicit-any */
import { DateRangeValue } from "components/DateRangePicker/types";

export enum FilterTypeEnum {
  TOGGLE = "toggle",
  CHECKBOX = "checkbox",
  DATE_RANGE = "date_range",
}

export type FilterValue = string[] | DateRangeFilterValue | any;

export enum DateRangeType {
  ALL_TIME = "all_time",
  LAST_7_DAYS = "last_7_days",
  LAST_30_DAYS = "last_30_days",
  LAST_90_DAYS = "last_90_days",
  CUSTOM_PERIOD = "custom_period",

  CUSTOM_VALUE = "custom_value",
}

export interface DateRangeOption {
  id: string;
  title: string;
  type: DateRangeType;
  value?: any;
}

export interface DateRangeFilterValue {
  id: string;
  range: DateRangeValue | null;
}

interface BaseFilterConfig<T> {
  id: keyof T;
  label: string;
  type: FilterTypeEnum;
}

export interface ToggleFilterConfig<T> extends BaseFilterConfig<T> {
  type: FilterTypeEnum.TOGGLE;
  children?: React.ReactNode;
  extractValues: () => string[];
  removeValue: () => string[];
}

interface CheckboxFilterConfig<T> extends BaseFilterConfig<T> {
  type: FilterTypeEnum.CHECKBOX;
  options: string[];
  emptyText?: string;
  extractValues: (activeFilters: string[]) => string[];
  removeValue: (activeFilters: string[], value: string) => string[];
}

interface DateRangeFilterConfig<T> extends BaseFilterConfig<T> {
  type: FilterTypeEnum.DATE_RANGE;
  options: DateRangeOption[];
  extractValues: (activeFilters: DateRangeFilterValue) => string[];
  removeValue: () => DateRangeFilterValue;
}

export type TableFilter<T> =
  | ToggleFilterConfig<T>
  | CheckboxFilterConfig<T>
  | DateRangeFilterConfig<T>;
